import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { getPlannedAds } from 'redux/modules/adsPlanner';
import { AdDashboardCard, Spinner } from 'components';
import lodash from 'lodash';
var PlannedAdWrap = (_dec = connect(function (state, props) {
  var orgId = state.organization.current.id;
  return {
    adsPlanner: state.adsPlanner && state.adsPlanner[orgId] ? state.adsPlanner[orgId] : null,
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  getPlannedAds: getPlannedAds
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PlannedAdWrap, _Component);

  var _super = _createSuper(PlannedAdWrap);

  function PlannedAdWrap() {
    var _this;

    _classCallCheck(this, PlannedAdWrap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatCategory", function (cat) {
      var s = lodash.startCase("".concat(cat).toLowerCase().replace(/_/g, ' '));

      if (s[s.length - 1] === 's') {
        return s.substr(0, s.length - 1);
      }

      return s;
    });

    return _this;
  }

  _createClass(PlannedAdWrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var adsPlan = this.props.adsPlanner[this.props.adsPlanner.currentPlanId];
      var startDate = moment(adsPlan.dateStart).subtract(3, 'months');
      var endDate = moment(adsPlan.dateEnd).subtract(1, 'month');
      var start = startDate.valueOf();
      var end = endDate.valueOf();
      this.props.getPlannedAds(this.props.organization.id, start, end, this.props.category);
    }
  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var adsPlan = this.props.adsPlanner;
      var plannedAds = adsPlan && this.props.adsPlanner.plannedAds && this.props.adsPlanner.plannedAds[this.props.category] ? this.props.adsPlanner.plannedAds[this.props.category] : [];
      return /*#__PURE__*/React.createElement("div", null, adsPlan && /*#__PURE__*/React.createElement("div", null, adsPlan.gettingPlannedAds ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 100
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, plannedAds.length > 0 ? plannedAds.map(function (ad, index) {
        var adCardStyle = {
          border: '3px solid transparent'
        };

        if (ad.id === _this2.props.selectedAdId) {
          adCardStyle.borderColor = _this2.props.theme.colors.secondaryColor;
        }

        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex'
          }
        }, ad.facebookAd && /*#__PURE__*/React.createElement(AdDashboardCard, {
          handleCardClick: function handleCardClick() {
            _this2.props.handleAdCardClick(ad.id);
          },
          key: index,
          type: _this2.props.category,
          adDetails: ad.facebookAd,
          style: adCardStyle
        }));
      }) : /*#__PURE__*/React.createElement("p", null, "You haven't created any ", this.formatCategory(this.props.category), " ads yet."))));
    }
  }]);

  return PlannedAdWrap;
}(Component)) || _class);
export { PlannedAdWrap as default };